import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import createLoadRemoteModule, { createRequires } from "@paciolan/remote-module-loader";
import { getDeps, setDeps } from "./deps";
var createLoader = function createLoader() {
  var dependencies = getDeps();
  var requires = createRequires(dependencies);
  return createLoadRemoteModule({
    requires: requires
  });
};
export var execModule = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(moduleConfig, deps) {
    var _ref2, name, _ref2$url, url, ret, loader, urlList, i, len, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (deps === void 0) {
              deps = null;
            }
            if (deps) {
              setDeps(deps);
            }
            _ref2 = moduleConfig || {}, name = _ref2.name, _ref2$url = _ref2.url, url = _ref2$url === void 0 ? [] : _ref2$url; // 按照顺序加载运行js模块
            _context.prev = 3;
            loader = createLoader();
            urlList = Array.isArray(url) ? url : typeof url === "string" ? [url] : [];
            i = 0, len = urlList.length;
          case 7:
            if (!(i < len)) {
              _context.next = 15;
              break;
            }
            _context.next = 10;
            return loader(urlList[i]);
          case 10:
            data = _context.sent;
            ret = Object.assign({}, ret, data);
          case 12:
            i++;
            _context.next = 7;
            break;
          case 15:
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            console.error("[engine-sdk] load modules err", _context.t0);
          case 20:
            return _context.abrupt("return", ret);
          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));
  return function execModule(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();